import {List} from 'immutable'
import PropTypes from 'prop-types'

import ManageAppEnrollment from './manage_tfa_setup/ManageAppEnrollment'
import ManagePhoneEnrollment from './manage_tfa_setup/ManagePhoneEnrollment'
import RecoveryCodes from './manage_tfa_setup/RecoveryCodes'

import './manageTfaSetup.scss'

const ManageTfaSetup = props => {
  switch (props.mode) {
    case 'app':
      return <ManageAppEnrollment {...props} />
    case 'phone':
      return <ManagePhoneEnrollment {...props} />
    case 'recovery':
      return <RecoveryCodes {...props} backupCodes={props.backupCodes} />
    default:
      return null
  }
}

ManageTfaSetup.propTypes = {
  backupCodes: PropTypes.instanceOf(List).isRequired,
  mode: PropTypes.string
}

export default ManageTfaSetup
